
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { google } from 'google-maps';
import MissionStore from '../../store/modules/missions';
import { getModule } from 'vuex-module-decorators';
import RenderColors from '@/flightpath-components/services/colors';
import { GpsHelper } from '@/flightpath-components/services/GpsHelper';
import { RenderHelper } from '@/services/RenderHelper';

@Component
export default class GoogleMapPolyLine extends Vue {
  @Prop() googleApi!: google;
  @Prop() map!: google.maps.Map<HTMLDivElement>;
  @Prop() polyline!: google.maps.PolylineOptions;

  mapPolyLine = null as google.maps.Polyline | null;
  missionStore = getModule(MissionStore, this.$store);
  startMarker: google.maps.Marker | null = null;
  endMarker: google.maps.Marker | null = null;

  destroyed() {
    this.mapPolyLine?.setMap(null);
    this.startMarker?.setMap(null);
    this.endMarker?.setMap(null);
  }

  mounted() {
    this.mapPolyLine = new this.googleApi.maps.Polyline({
      path: this.polyline.path,
      map: this.map,
      strokeColor: this.polyline.strokeColor,
      visible: this.polyline.visible
    });

    this.updatePathLengthAndMarkers();
  }

  @Watch('polyline')
  onLineChange() {
    if (this.mapPolyLine) {
      this.mapPolyLine.setPath(this.polyline.path as Array<google.maps.LatLng>);
      this.mapPolyLine.setVisible(true);
    }

    this.updatePathLengthAndMarkers();
  }

  updatePathLengthAndMarkers() {
    if (this.polyline.strokeColor == RenderColors.PlannedPath) {
      try {
        const pathLengthMeters = Math.round(GpsHelper.findPathLengthInMeters(this.polyline.path as google.maps.LatLng[]));
        this.missionStore.setPathLengthKm(Math.round(pathLengthMeters) / 1000);
      } catch (err) {
        console.error(err);
      }

      if (this.startMarker) this.startMarker.setMap(null);
      this.startMarker = RenderHelper.createStartMakerWithLabel(this.mapPolyLine as google.maps.Polyline);
      this.startMarker.setMap(this.map);

      if (this.endMarker) this.endMarker.setMap(null);
      this.endMarker = RenderHelper.createStopMakerWithLabel(this.mapPolyLine as google.maps.Polyline);
      this.endMarker.setMap(this.map);
    }
  }
}
